import { render, staticRenderFns } from "./OrganizationJoin.vue?vue&type=template&id=7408d34c&"
import script from "./OrganizationJoin.vue?vue&type=script&lang=js&"
export * from "./OrganizationJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports